import apiMap from '../../../apis/apiMap.mjs'
import parseMap from '../../../scripts/parseMap.mjs'

export const canReviseMap = () => () => {
    return function () {
        if ('RLS' !== this.data.mapStsCode) {
            this.logger.error('只有发布状态的地图才能修订')
            return false
        }

        if (! this.permission.has('revise')) {
            this.logger.error('没有修订权限')
            return false
        }

        return true
    }
}

export const reviseMap = () => {
    return () => function () {
        return this.runAction(
            async () => {
                const {pkid} = this.data
                const {mapModel, ...updates} = await apiMap.revise({pkid})
                this.data = {...this.data, ...updates}
                const {root} = parseMap(mapModel)
                const _n = this.nodeProxy(this.root)
                await _n.replace(root)
            },

            {action: '修订地图'},
        )
    }
}
